import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Typography, Container, Box, Alert } from '@mui/material';
import api from '../api/api';

function RegisterPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (email !== confirmEmail) {
            setError(t('common.emailsDoNotMatch'));
            return;
        }

        try {
            await api.post('/user/register', { username, password, name, email });
            setMessage(t('common.registrationSuccess'));
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (err) {
            setError(t('common.errorOccurred', { message: err.response?.data?.message || err.message }));
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    {t('common.register')}
                </Typography>
                {message && <Alert severity="success" sx={{ mt: 2, width: '100%' }}>{message}</Alert>}
                {error && <Alert severity="error" sx={{ mt: 2, width: '100%' }}>{error}</Alert>}
                <Box component="form" onSubmit={handleRegister} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label={t('common.username')}
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label={t('common.password')}
                        type="password"
                        id="password"
                        autoComplete="new-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label={t('common.name')}
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label={t('common.email')}
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="confirmEmail"
                        label={t('common.confirmEmail')}
                        name="confirmEmail"
                        autoComplete="email"
                        value={confirmEmail}
                        onChange={(e) => setConfirmEmail(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        {t('common.register')}
                    </Button>
                    <Link to="/login" style={{ textDecoration: 'none' }}>
                        <Button fullWidth variant="outlined" sx={{ mb: 2 }}>
                            {t('common.login')}
                        </Button>
                    </Link>
                </Box>
            </Box>
        </Container>
    );
}

export default RegisterPage;